/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { copyPositionToNewCompanyAsync$Json } from '../fn/job/copy-position-to-new-company-async-json';
import { CopyPositionToNewCompanyAsync$Json$Params } from '../fn/job/copy-position-to-new-company-async-json';
import { copyPositionToNewCompanyAsync$Plain } from '../fn/job/copy-position-to-new-company-async-plain';
import { CopyPositionToNewCompanyAsync$Plain$Params } from '../fn/job/copy-position-to-new-company-async-plain';
import { getJobAsync_1$Json } from '../fn/job/get-job-async-1-json';
import { GetJobAsync_1$Json$Params } from '../fn/job/get-job-async-1-json';
import { getJobAsync_1$Plain } from '../fn/job/get-job-async-1-plain';
import { GetJobAsync_1$Plain$Params } from '../fn/job/get-job-async-1-plain';
import { getJobAsync$Json } from '../fn/job/get-job-async-json';
import { GetJobAsync$Json$Params } from '../fn/job/get-job-async-json';
import { getJobAsync$Plain } from '../fn/job/get-job-async-plain';
import { GetJobAsync$Plain$Params } from '../fn/job/get-job-async-plain';
import { getJobsByCompanyAsync$Json } from '../fn/job/get-jobs-by-company-async-json';
import { GetJobsByCompanyAsync$Json$Params } from '../fn/job/get-jobs-by-company-async-json';
import { getJobsByCompanyAsync$Plain } from '../fn/job/get-jobs-by-company-async-plain';
import { GetJobsByCompanyAsync$Plain$Params } from '../fn/job/get-jobs-by-company-async-plain';
import { PositionCto } from '../models/position-cto';
import { updateJobArchiveStatusAsync$Json } from '../fn/job/update-job-archive-status-async-json';
import { UpdateJobArchiveStatusAsync$Json$Params } from '../fn/job/update-job-archive-status-async-json';
import { updateJobArchiveStatusAsync$Plain } from '../fn/job/update-job-archive-status-async-plain';
import { UpdateJobArchiveStatusAsync$Plain$Params } from '../fn/job/update-job-archive-status-async-plain';

@Injectable({ providedIn: 'root' })
export class JobService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getJobAsync()` */
  static readonly GetJobAsyncPath = '/job/{positionGuid}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync$Plain$Response(params: GetJobAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
    return getJobAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync$Plain(params: GetJobAsync$Plain$Params, context?: HttpContext): Observable<PositionCto> {
    return this.getJobAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PositionCto>): PositionCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync$Json$Response(params: GetJobAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
    return getJobAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync$Json(params: GetJobAsync$Json$Params, context?: HttpContext): Observable<PositionCto> {
    return this.getJobAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PositionCto>): PositionCto => r.body)
    );
  }

  /** Path part for operation `getJobAsync_1()` */
  static readonly GetJobAsync_1Path = '/job/{positionId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobAsync_1$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync_1$Plain$Response(params: GetJobAsync_1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
    return getJobAsync_1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobAsync_1$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync_1$Plain(params: GetJobAsync_1$Plain$Params, context?: HttpContext): Observable<PositionCto> {
    return this.getJobAsync_1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PositionCto>): PositionCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobAsync_1$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync_1$Json$Response(params: GetJobAsync_1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
    return getJobAsync_1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobAsync_1$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobAsync_1$Json(params: GetJobAsync_1$Json$Params, context?: HttpContext): Observable<PositionCto> {
    return this.getJobAsync_1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PositionCto>): PositionCto => r.body)
    );
  }

  /** Path part for operation `getJobsByCompanyAsync()` */
  static readonly GetJobsByCompanyAsyncPath = '/job/company/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobsByCompanyAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobsByCompanyAsync$Plain$Response(params: GetJobsByCompanyAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PositionCto>>> {
    return getJobsByCompanyAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobsByCompanyAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobsByCompanyAsync$Plain(params: GetJobsByCompanyAsync$Plain$Params, context?: HttpContext): Observable<Array<PositionCto>> {
    return this.getJobsByCompanyAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PositionCto>>): Array<PositionCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getJobsByCompanyAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobsByCompanyAsync$Json$Response(params: GetJobsByCompanyAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PositionCto>>> {
    return getJobsByCompanyAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getJobsByCompanyAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getJobsByCompanyAsync$Json(params: GetJobsByCompanyAsync$Json$Params, context?: HttpContext): Observable<Array<PositionCto>> {
    return this.getJobsByCompanyAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<PositionCto>>): Array<PositionCto> => r.body)
    );
  }

  /** Path part for operation `updateJobArchiveStatusAsync()` */
  static readonly UpdateJobArchiveStatusAsyncPath = '/job/{positionGuid}/archive';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateJobArchiveStatusAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateJobArchiveStatusAsync$Plain$Response(params: UpdateJobArchiveStatusAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
    return updateJobArchiveStatusAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateJobArchiveStatusAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateJobArchiveStatusAsync$Plain(params: UpdateJobArchiveStatusAsync$Plain$Params, context?: HttpContext): Observable<PositionCto> {
    return this.updateJobArchiveStatusAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PositionCto>): PositionCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateJobArchiveStatusAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateJobArchiveStatusAsync$Json$Response(params: UpdateJobArchiveStatusAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PositionCto>> {
    return updateJobArchiveStatusAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateJobArchiveStatusAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateJobArchiveStatusAsync$Json(params: UpdateJobArchiveStatusAsync$Json$Params, context?: HttpContext): Observable<PositionCto> {
    return this.updateJobArchiveStatusAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PositionCto>): PositionCto => r.body)
    );
  }

  /** Path part for operation `copyPositionToNewCompanyAsync()` */
  static readonly CopyPositionToNewCompanyAsyncPath = '/job/copyPositionToNewCompany';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyPositionToNewCompanyAsync$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  copyPositionToNewCompanyAsync$Plain$Response(params?: CopyPositionToNewCompanyAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return copyPositionToNewCompanyAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `copyPositionToNewCompanyAsync$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  copyPositionToNewCompanyAsync$Plain(params?: CopyPositionToNewCompanyAsync$Plain$Params, context?: HttpContext): Observable<string> {
    return this.copyPositionToNewCompanyAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `copyPositionToNewCompanyAsync$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  copyPositionToNewCompanyAsync$Json$Response(params?: CopyPositionToNewCompanyAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    return copyPositionToNewCompanyAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `copyPositionToNewCompanyAsync$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  copyPositionToNewCompanyAsync$Json(params?: CopyPositionToNewCompanyAsync$Json$Params, context?: HttpContext): Observable<string> {
    return this.copyPositionToNewCompanyAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
